module.exports = __webpack_public_path__ + "static/media/notification-dark.5885ac9f.svg";